import { useEffect, useMemo, useState } from 'react';

import { MdFilterList } from 'react-icons/md';
import { useParams } from 'react-router-dom';
import { MoonLoader } from 'react-spinners';

import { ButtonBlack } from '~/components';
import { BillingProps } from '~/models';
import api from '~/services/api';

import Modal from './Modal';
import TrainingProgramCard from './TrainingProgramCard';

import {
  ButtonWrapper,
  CardContainer,
  FilterButton,
  FilterLabel,
  ModalFilterContent,
  ModalQuestion,
  ModalTitle,
  NewButtonContainer,
  Wrapper,
  AlertContainer,
  NoDataFound,
} from './styles';

type RouteParams = {
  userId: string;
};

export function TrainingPrograms() {
  const { userId: studentId } = useParams<RouteParams>();

  const [loading, setLoading] = useState(true);
  const [trainingProgramsModal, setTrainingProgramsModal] = useState(false);
  const [billings, setBillings] = useState<BillingProps[]>([]);

  useEffect(() => {
    async function fetchData() {
      const { data } = await api.get(`/students/${studentId}/billings`);

      setBillings(data);
    }

    fetchData();

    setLoading(false);
  }, [studentId]);

  const TrainingProgramsModal = () => (
    <Modal
      isOpen={trainingProgramsModal}
      setOpen={setTrainingProgramsModal}
      maxWidthStyled={621}
      maxHeightStyled={428}
    >
      <ModalFilterContent>
        <ModalTitle>Filtrar</ModalTitle>

        <ModalQuestion>
          <h2>ID de fatura:</h2>

          <div className="date_register">
            <input type="number" placeholder="ID" />
          </div>
        </ModalQuestion>

        <ModalQuestion>
          <h2>Data de Cadastro:</h2>

          <div className="date_register">
            <input type="number" placeholder="Dia" />
            <input type="number" placeholder="Mês" />
            <input type="number" placeholder="Ano" />
          </div>
        </ModalQuestion>

        <ButtonBlack>Aplicar</ButtonBlack>
      </ModalFilterContent>
    </Modal>
  );

  const cardsMemo = useMemo(
    () =>
      billings.length > 0 ? (
        <CardContainer>
          {billings.map((billing) => (
            <TrainingProgramCard key={billing.id} billing={billing} />
          ))}
        </CardContainer>
      ) : (
        <NoDataFound>
          <p>Nenhuma programa de treino disponível!</p>
        </NoDataFound>
      ),
    [billings],
  );

  return (
    <>
      <TrainingProgramsModal />

      <NewButtonContainer>
        <ButtonWrapper secondary filter>
          <FilterButton onClick={() => setTrainingProgramsModal(true)}>
            <FilterLabel filter>Filtrar</FilterLabel>
            <span>
              <MdFilterList size={30} color="#fff" />
            </span>
          </FilterButton>
        </ButtonWrapper>
      </NewButtonContainer>

      <Wrapper>
        {loading ? (
          <AlertContainer>
            <MoonLoader size={30} color="#FFDF22" />
          </AlertContainer>
        ) : (
          cardsMemo
        )}
      </Wrapper>
    </>
  );
}
